/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleSpace from './space/moduleSpace.js'
import moduleProject from './project/moduleProject.js'
import moduleNotice from './notice/moduleNotice.js'
import moduleAlarm from './alarm/moduleAlarm.js'
import moduleNoticeBoard from './noticeBoard/moduleNoticeBoard.js'
import moduleSubmit from './submit/moduleSubmit.js'
import moduleEtest from './etest/moduleETest.js'
import moduleInsight from './insight/moduleInsight.js'
import moduleSearchUser from './searchUser/moduleSearchUser.js'
// import moduleStudentNotice from './studentNotice/moduleStudentNotice.js'
// import moduleDataList from './data-list/moduleDataList.js'
import moduleTask from './task/moduleTask.js'

export default new Vuex.Store({
    getters,
    mutations,
    state,
    actions,
    modules: {
        // todo: moduleTodo,
      // calendar: moduleCalendar,
      // chat: moduleChat,
      // email: moduleEmail,
      space: moduleSpace,
      auth: moduleAuth,
      eCommerce: moduleECommerce,
      project: moduleProject,
      notice: moduleNotice,
      noticeBoard: moduleNoticeBoard,
      submit: moduleSubmit,
      alarm: moduleAlarm,
      // dataList: moduleDataList,
      task:moduleTask,
      etest:moduleEtest,
      insight:moduleInsight,
      searchUser: moduleSearchUser,
      // studentNotice:moduleStudentNotice
    },
    strict: process.env.NODE_ENV !== 'production'
})
